import { createContext, useContext } from "react";

/**
 * A scoped element for portaled overlays (Dialog, Sheet) to render into instead of `document.body`,
 * so CSS custom properties set on a wrapper (e.g. an organization theme) still reach the overlay. A
 * `container` passed directly to a portal takes precedence.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

export const usePortalContainer = () => useContext(PortalContainerContext);
